import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const confidenceSegmentsPlugin = createPlugin({
  id: 'confidence-flags-module-segments',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindSegmentsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidenceSegmentsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...confidenceSegmentsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceSegmentsExtension = confidenceSegmentsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceSegmentsExtension',
    component: () =>
      import(
        /* webpackChunkName: "confidence-flags-module-segments", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
